import { RuleSet } from "shared/app/VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/types";
import { ScreeningCriteriaType } from "shared/app/VerificationTemplate/slices/DecisionCriteria/types";
import { Money } from "types/landlord/reports";
import {
  VerificationSchema,
  Template,
  RecommendationMethod
} from "types/landlord/verificationTemplate";

export interface TemplateResponse {
  verification_template: Template;
}

export interface VerificationSchemasResponse {
  verification_schemas: VerificationSchema[];
}

export interface GetTemplatesResponse {
  object: string;
  current_page: number;
  extra: null | any;
  has_more: boolean;
  items: Template[];
  page_count: number;
  total_count: number;
}

// TODO: Remove this interface. We have Template.
export interface IdTemplateResponse extends TemplateSettings {
  id: string;
  name: string;
  applicant_fee: Money;
  applicant_screening_cost: Money;
  co_signer_fee: Money;
  co_signer_screening_cost: Money;
  created_at: string;
  created_by?: {
    email: string;
    id: number;
    name: string;
  };
  default: boolean;
  updated_at: string;
  updated_by?: {
    email: string;
    id: number;
    name: string;
  };
  verification_schemas: VerificationSchema[];
  recommendation_method?: RecommendationMethod;
  screening_criteria?: ScreeningCriteriaType;
  rule_criteria?: RuleSet[];
}

export enum UnlistUnitTiming {
  NEVER = "never",
  ON_FIRST_APPLICATION = "on_first_application",
  ON_APPROVE = "on_approve"
}

export interface TemplateSettings {
  automatically_unlist_unit_timing: UnlistUnitTiming;
  notify_applicants: boolean;
  display_rent_amount: boolean;
  display_available_date: boolean;
  has_pet_rent: boolean;
  has_voucher: boolean;
  pet_rent_value?: Money;
  has_move_in_date_limit: boolean;
  max_move_in_days?: number;
  auto_approve_enabled?: boolean;
  auto_approve_delay?: number;
  auto_approve_delay_enabled?: boolean;
  auto_approve_delay_type?: string;
  auto_approve_delay_value?: number;
}
